/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useRef, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import {
    TableRow, TableCell, TextField, InputAdornment, Button, IconButton, Box,
    TableContainer, Paper, Table, TableHead, TableBody
} from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Space, Image } from "antd";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../Shared/components/Icons/Search";
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { checkCRUDPermission } from "../../../../../helpers/utilities";

const ClientTable = (props) => {
    const { showDetails, rows, roleId,
        loadTasks, visible, handleClientClose, clientAddMore, heads } = props;
    const { createLoader, createDetails, roleManagement } = useSelector(state => state.crudReducer);
    const { businessListDetails, businessListLoader } = useSelector(state => state.homeReducer);
    const [deleteModal, setDeleteModal] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [clientId, setClienId] = useState('');
    const [clientName, setClienName] = useState('');
    const prevCreateDetails = usePrevious(createDetails);

    const [addressVisible, setAddressVisible] = useState(false);
    // const [sortOrder, setSortOrder] = useState("asc");
    // const [sortBy, setSortBy] = useState("businessName");

    const sortOrder = "asc";
    const sortBy = "businessName";
    const [addressSearchAll, setAddressSearchAll] = useState('');
    const prevAddressSearchAll = usePrevious(addressSearchAll);
    const [iconAnimation, setIconAnimation] = useState(false);
    const timeoutRef = useRef('');


    const dispatch = useDispatch();

    const [form, setForm] = useState({
        businessId: "",
        roleId: parseInt(roleId)
    });

    const [otherFields, setOtherFields] = useState({
        clientId: "",
        number: "",
        name: "",
    });

    const changeHandler = (e) => {
        setOtherFields({
            ...otherFields,
            [e.target.name]: e.target.value,
        });
    };

    const handleClose = () => {
        handleClientClose('client');
        emptyState();
        emptyStateInput();
    };

    const emptyStateInput = () => {
        setForm({
            businessId: "",
            roleId: parseInt(roleId)
        });
        setOtherFields({
            clientId: "",
            number: "",
            name: "",
        });
    }

    const emptyState = () => {
        setErrorName(false);
    }

    const handleAddMore = (e) => {
        addClient(e);
        clientAddMore(true);
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            handleClose();
        }
    }, [createDetails]);

    const addClient = (e) => {
        e.preventDefault();
        emptyState('');
        if (otherFields.clientId !== '') {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'roleClients',
                title: 'Role Clients',
                details: form
            });
        } else {
            setErrorName('Please select client details');
        }

    }

    const handleAddressOpen = () => {
        setAddressVisible(true);
    }

    const addressSearch = () => {
        let filter = {
            ["and"]: [{ isGloballyVisible: true }, { businessId: { neq: null } }]
        };
        let data = false;
        let or = { ["or"]: [] };
        if (otherFields?.name?.length > 2) {
            data = true;
            or['or'].push({ businessName: { like: otherFields.name.trim() + '%' } });
            or['or'].push({ contactName: { like: otherFields.name.trim() + '%' } });
            or['or'].push({ email: { like: otherFields.name.trim() + '%' } });
            handleAddressOpen();
        }

        if (otherFields?.clientId?.length > 2) {
            data = true;
            filter['and'].push({ userId: { like: otherFields.clientId.trim() + '%' } });
            handleAddressOpen();
        }

        if (otherFields?.number?.length > 2) {
            data = true;
            filter['and'].push({ mobile: { like: otherFields.number.trim() + '%' } });
            handleAddressOpen();
        }

        filter['and'].push(or);
        if (data) {
            dispatch({
                type: globalAddressActions.BUSINESS_LIST_START,
                url: 'addressBook',
                filter: {
                    where: filter,
                    order: sortBy + ' ' + sortOrder
                }
            });
        }
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setClienName(data?.business?.name);
        setClienId(data?.id);
    }

    useEffect(() => {
        if ((prevAddressSearchAll !== undefined && addressSearchAll && addressSearchAll.length > 2 && prevAddressSearchAll !== addressSearchAll) || (prevAddressSearchAll !== undefined && addressSearchAll === '' && prevAddressSearchAll !== addressSearchAll)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                let filter = { ["and"]: [{ isGloballyVisible: true }, { businessId: { neq: null } }] };
                let or = { ["or"]: [] };
                or['or'].push({ businessName: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ contactName: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ mobile: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ email: { like: addressSearchAll.trim() + '%' } });
                filter['and'].push(or);
                dispatch({
                    type: globalAddressActions.BUSINESS_LIST_START,
                    url: 'addressBook',
                    filter: {
                        where: filter,
                        order: sortBy + ' ' + sortOrder
                    }
                });
            }, 500);
        }
    }, [addressSearchAll]);

    const handleAddressClose = () => {
        setAddressVisible(false)
    }

    const selectAddress = (data) => {
        setForm({
            ...form,
            businessId: data.businessId,
        });
        setOtherFields({
            ...otherFields,
            clientId: data.businessId,
            name: data.businessName ? data.businessName : data.contactName,
            number: data.mobile
        });
        handleAddressClose();
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            {
                showDetails || rows === '' ? (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell style={{ textAlign: "center" }} colSpan={3}><div className={classes.loadMoreCircle}></div></TableCell>
                    </TableRow>
                ) : (
                    <React.Fragment>
                        {
                            rows && rows?.length > 0 ? rows?.map((data, i) => (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                    <TableCell>{data?.business?.name}</TableCell>
                                    <TableCell>{data?.businessId ? `YOU${data.businessId}` : '----'}</TableCell>
                                    <TableCell>
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                <Image
                                                    src={DeleteIcon}
                                                    preview={false}
                                                />
                                            </NavLink>
                                        }
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={heads.length}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No Clients Added Here'}</p>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </React.Fragment>
                )
            }
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Add Client'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => addClient(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={'Client'}
                                fullWidth
                                error={errorName && true}
                                helperText={errorName}
                                value={otherFields.name}
                                name={'name'}
                                variant={'standard'}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end" onClick={() => addressSearch()}>
                                            <IconButton>
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                    required: true
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={'Client ID'}
                                fullWidth
                                className={clsx(classes.margin20t)}
                                error={errorName && true}
                                helperText={errorName}
                                value={otherFields.clientId}
                                name={'clientId'}
                                variant={'standard'}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">YOU
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end" onClick={() => addressSearch()}>
                                            <IconButton>
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                    required: true
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                            <TextField autoComplete='one-time-code'
                                label={'Mobile Number'}
                                fullWidth
                                className={clsx(classes.margin20t)}
                                error={errorName && true}
                                helperText={errorName}
                                value={otherFields.number}
                                name={'number'}
                                variant={'standard'}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end" onClick={() => addressSearch()}>
                                            <IconButton>
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                    required: true
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                >
                                    Save & Close
                                </Button>
                                <Button
                                    key="add"
                                    onClick={(e) => handleAddMore(e)}
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                >
                                    Add more
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={addressVisible}
                variant={'temporary'}
                handleClose={() => handleAddressClose()}
                width={'695px'}
                title={'Select Client Name - Global Search'}
                className={clsx(classes.closeBackGround)}
                component={
                    <Box className={clsx(classes.addressBookContainer)}>
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                            <TextField autoComplete='one-time-code'
                                placeholder='Search'
                                type='search'
                                fullWidth
                                onChange={(e) => setAddressSearchAll(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image
                                src={SearchIcon}
                                preview={false}
                            />
                        </div>
                        <TableContainer component={Paper}>
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={"23%"}>{'Supplier Name Supplier ID'}</TableCell>
                                        <TableCell className={classes.padding10L} width={"20%"}>{'Mobile Number'}</TableCell>
                                        <TableCell className={classes.padding10L} width={"25%"}>{'Email'}</TableCell>
                                        <TableCell className={classes.padding10L} width={"40%"}>{'Address'}</TableCell>
                                        <TableCell className={classes.padding10L} width={"10%"}>{'Action'}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        businessListLoader === false && businessListDetails && businessListDetails.length > 0 && businessListDetails.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell>
                                                    <div>{data.businessName ? data.businessName : data.contactName}</div>
                                                    <div className={clsx(classes.margin10t)}>{data.businessId ? `YOU${data.businessId}` : '---'}</div>
                                                </TableCell>
                                                <TableCell>{data.mobile ? data.mobile : '---'}</TableCell>
                                                <TableCell>{data.email ? data.email : '---'}</TableCell>
                                                <TableCell>{`${data.address ? data.address + ',' : '---,'} ${data.area ? data.area.name + ',' : ''} ${data.city ? data.city.name + ',' : ''} ${data.pincode ? data.pincode.code + ',' : ''} ${data.state ? data.state.name + ',' : ''} ${data.country ? data.country.name : ''}`}</TableCell>

                                                <TableCell><NavLink to={'#'} onClick={() => selectAddress(data)} className={clsx(classes.color, classes.bold)}>{'Select'}</NavLink></TableCell>
                                            </TableRow>
                                        ))
                                    }
                                    {
                                        businessListLoader === false && businessListDetails && businessListDetails.length === 0 && (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={4}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                    {
                                        businessListLoader === true && (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={4}><div className={classes.loadMoreCircle}></div></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => { setDeleteModal(v) }} loadTasks={() => loadTasks()}
                name={clientName}
                id={clientId} url={'roleClients'} title={'Role Clients'} visible={deleteModal} />
        </React.Fragment>
    );
}

export default ClientTable;